import React from "react";
import { ChatContainer } from "../../../../ui-kit/ChatMessage/ChatMessage";
import { useWebTranslation } from "../../../../translations";
import { StepProps } from "../types";
import {
  useAllValidAnimals,
  useBillingInterval,
  useTotalCost,
} from "components/Signup/store/selectors/animals";
import FlowButtons from "components/Signup/components/FlowButtons/FlowButtons";
import { SummaryCard } from "components/Signup/components/SummaryCard";
import GrandPrice from "components/Signup/components/GrandPrice";
import { isOrg } from "utils/site";
import { SavingsBanner } from "components/Signup/components/SavingsBanner";
import { Typography } from "ui-kit/Typography";

const Summary = ({ next, transitioning, previous, isValid }: StepProps) => {
  const { t } = useWebTranslation();
  const animals = useAllValidAnimals();
  const billingInterval = useBillingInterval();
  const totalCost = useTotalCost();

  return (
    <>
      <ChatContainer leaving={transitioning}>
        <div>
          <div style={{ display: "flex", gap: 16, flexDirection: "column" }}>
            <Typography variant="body1" align="center">
              <strong>
                {animals.length > 1
                  ? t("signup.draft_summary.title", { number: animals.length })
                  : t("global.insurance_animal", {
                      name: animals[0].name ?? "",
                    })}
              </strong>
            </Typography>
            <GrandPrice
              billingInterval={billingInterval}
              amountToPay={totalCost}
            />

            <SavingsBanner />

            <SummaryCard showButtons />
          </div>
        </div>
        <FlowButtons
          inProgress={transitioning}
          next={next}
          disabled={!isValid}
          previous={previous}
          backButton={false}
        />
      </ChatContainer>
    </>
  );
};

export default Summary;
